import { getLastQuery } from "../components/helper";

const url = window.location.pathname;
const locale = window.heroLocale;

function fetchCalendly() {
    var script = document.createElement('script');
    script.type = "text/javascript";
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.id = "calendlyScript";
    (document.getElementsByTagName('body')[0]).appendChild(script);
    var link = document.createElement('link');
    link.rel = "stylesheet";
    link.id = "calendlyLink";
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    (document.getElementsByTagName('body')[0]).appendChild(link);
}

function executeCalendly() {
    var query = getLastQuery() || '';
    let url;
    if (Cookiebot?.consent?.preferences) {
        url = `${window.calendlyUrl}?hide_gdpr_banner=1?${query}`;
    } else {
        url = `${window.calendlyUrl}?${query}`;
    }
    if (Calendly.showPopupWidget) {
        Calendly.showPopupWidget(url);
    } else {
        window.open(url, '_blank').focus();
    }
}


fetchCalendly()
setCalendyUrl();

const showCalendly = () => {
    // if (!document.getElementById("calendlyScript") && !document.getElementById("calendlyLink")) {
    //     fetchCalendly();
    // }
    setCalendyUrl();
    executeCalendly()
}

window.showCalendly = showCalendly;

let payBetaButtons = document.querySelectorAll("a.pay-beta");

if(payBetaButtons) {
    payBetaButtons.forEach(payBetaButton=> {
        payBetaButton.addEventListener('click', () => {
            window.calendlyUrl = 'https://calendly.com/niklas-palm/hero-pay-closed-beta';
            executeCalendly();
        });
    })
}

let calendlyPopup = document.querySelectorAll("a.calendly-popup");

if(calendlyPopup) {
    calendlyPopup.forEach(calendlyPopup=> {
        calendlyPopup.addEventListener('click', () => {
            window.calendlyUrl = calendlyUrlInputBanner;
            executeCalendly();
        });
    })
}


function setCalendyUrl() {
    if (window.calendlyUrlInputCraft) {
        window.calendlyUrl = calendlyUrlInputCraft;
        } else if (locale === 'fr-FR') {
            window.calendlyUrl = 'https://calendly.com/hero-europe/premiere-consultation';
        } else if (locale === 'es-ES') {
            window.calendlyUrl = 'https://calendly.com/hero-europe/consultation-es';
        } else if (locale === 'it-IT') {
            window.calendlyUrl = 'https://calendly.com/hero-europe/consultation-it';
        } else if (locale === 'nl-NL') {
            window.calendlyUrl = 'https://calendly.com/hero-europe/telefonisch-eerste-consult';
        } else if (url === '/lp-some') {
            window.calendlyUrl = 'https://calendly.com/hero-handwerkersoftware/15-minuten-erstberatung-socials';
        } else {
            window.calendlyUrl = 'https://calendly.com/d/cqxs-jrr-ynb';
        }
    }


const demoterminButton = document.querySelector("a#signup-demo-fixed");

if(demoterminButton) {
    demoterminButton.addEventListener('contextmenu', event => {
        event.preventDefault();
        executeCalendly();
    });
}
